import { getInstance } from "../core/axios-gateway";

const BASE_PATH = "/api/metrics/textiles/purchases/detail";
const SEARCH_BY_PAYMENT_PATH = "/api/metrics/textiles/purchases/search-by-payment-id";

export interface TTextilePurchase {
  fecha_pedido: string;
  id: string;
  kam: string;
  payment_method: string;
  payment_status: string;
  purchase_number: string;
  revenue_con_iva: number;
  revenue_sin_iva: number;
  status: string;
}

export interface TTextilesPurchasesParams {
  month: string;
}

export interface TTextilePaymentSearchResult {
  final_amount: number;
  id: number;
  inicial_amount: number;
  provider: string;
  reference: string;
  reference_id: string;
  status: string;
}

export interface TCostoPlatamDetail {
  purchase_number: string;
  purchase_id: string;
  final_amount: number;
  payment_id: number;
  initial_amount: number;
  client: string;
  document: string;
  category_id: string;
  discount_rate: number;
  discount: number;
}

export interface TCostoPlatamResponse {
  month: string;
  total_cost: number;
  detail: TCostoPlatamDetail[];
}

export const getTextilesPurchases = async (params: TTextilesPurchasesParams) => {
  return getInstance()
    .get<TTextilePurchase[]>(BASE_PATH, { params })
    .then((res) => res.data);
};

export const searchTextilesByPaymentId = async (paymentId: string) => {
  return getInstance()
    .get<TTextilePaymentSearchResult>(SEARCH_BY_PAYMENT_PATH, {
      params: { payment_id: paymentId },
    })
    .then((res) => res.data);
};

export const getCostoPlatam = async (params: TTextilesPurchasesParams) => {
  return getInstance()
    .get<TCostoPlatamResponse>("/api/metrics/textiles/costo_platam", { params })
    .then((res) => res.data);
};

// Desembolsos Platam
export interface TDesembolsoOrder {
  purchase_number: string;
  purchase_id: string;
  payment_id: number | null;
  client: string | null;
  document: string | null;
  delivered_at: string;
  category_id: string;
  days_delay: number;
  disbursement_date: string;
  final_amount: number;
  discount_rate: number;
  discount: number;
  disbursement: number;
}

export interface TDesembolsoCutoff {
  cutoff_date: string;
  is_past: boolean;
  total_disbursement: number;
  total_discount: number;
  orders: TDesembolsoOrder[];
}

export interface TDesembolsosPlatamResponse {
  cutoffs: TDesembolsoCutoff[];
}

export const getTextilesCost = async (params: { con_iva?: boolean }) => {
  return getInstance()
    .get<Record<string, number>>("/api/metrics/textiles/cost", { params })
    .then((res) => res.data);
};

export const getDesembolsosPlatam = async () => {
  return getInstance()
    .get<TDesembolsosPlatamResponse>("/api/metrics/textiles/desembolsos_platam")
    .then((res) => res.data);
};